var defineWellKnownSymbol = require('../internals/define-well-known-symbol'); // `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-using-statement


defineWellKnownSymbol('dispose');